module.exports = __webpack_public_path__ + "img/xbc.c97015c3.svg";